import React from 'react'

import LoginHeader from './LoginHeader'

const loginScreenContainer = WrappedComponent => {

  return class Container extends React.Component {

    render() {
      return (
        <div style={styles.container}>
          <LoginHeader />
          <WrappedComponent {...this.props} />
        </div>
      )
    }
    
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }
}

export default loginScreenContainer



// WEBPACK FOOTER //
// ./src/login/loginScreenContainer.js